<script setup lang="ts">
import Multiselect from "@vueform/multiselect"
import PureMultiselectInfiniteScroll from '@/Components/Pure/PureMultiselectInfiniteScroll.vue';
import { routeType } from '@/types/route'
import Fieldset from 'primevue/fieldset'
import { get } from 'lodash-es'

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faExclamationCircle, faCheckCircle } from '@fas'
import { library } from "@fortawesome/fontawesome-svg-core"
import { computed, inject, onMounted, ref } from "vue"
import Icon from "@/Components/Utils/Icon.vue";
import PureInput from "@/Components/Pure/PureInput.vue";
import { layoutStructure } from "@/Composables/useLayoutStructure";
import { Link } from "@inertiajs/vue3";
import { RadioButton } from "primevue";
library.add(faExclamationCircle, faCheckCircle)

const props = defineProps<{
    form: any
    fieldName: any
    options: {
        products_type: {

        }
        brands: {}
        products: {}
        design_type: string[]
    }
    fieldData: {
        placeholder?: string
        required?: boolean
        mode?: "multiple" | "single" | "tags"
		searchable?: boolean
        readonly?: boolean
		labelProp?: string
		valueProp?: string
        fetchBrandsRoute: routeType
        fetchProductRoute: {
            [key: string]: routeType
        }
        manufacture?: {
            state: string
        }
        start_value: {
            product: {}[]
            brand: {}[]
            child_order?: {}[]
            child_order_product_id?: {}[]
        }
    }
    sectionFields: any  // the full sections
}>()

const layout = inject('layout', layoutStructure)
// console.log('FieldsOzzzzrder', layout.auth.role)

// Auto assign to first option if 'required' and value is null
onMounted(() => {
    if(props.fieldData?.required && !props.form[props.fieldName]) {
        props.form[props.fieldName] = props.options?.[0]?.value
    }
})

const compProductsRoute = computed(() => {
    return props.fieldData?.fetchProductRoute?.[props.form?.[props.fieldName] || 'polos']
})

const selectedProduct = ref<{} | null>(props.fieldData?.start_value?.product?.[0] || null)
const selectedWithTutup = ref<{} | null>(props.fieldData?.start_value?.child_order_product_id?.[0] || null)

const generateLinkEditOrder = (childOrder: any) => {
    if (!childOrder?.slug) {
        return ''
    }
    
    if (layout.auth.role === 'super_admin') {
        return route('master.orders-m.edit', childOrder.slug)
    } else {
        return route('sales.orders.edit', childOrder.slug)
    }
}

const optionsKeteranganCetak = [
    {
        value: 'satu_lembar',
        label: 'Satu lembar (1 produk tutup untuk 1 produk utama)'
    },
    {
        value: 'dua_lembar',
        label: 'Dua lembar (1 produk tutup untuk 2 produk utama)'
    },
]
</script>

<template>
	<div class="">
        <!-- Type -->
		<div class="mt-2">
            <div class="relative"
                :class="form.errors[fieldName] ? 'errorShake' : ''"
            >
                <Multiselect
                    v-model="form[fieldName]"
                    @update:modelValue="() => (form.errors[fieldName] = null, form['product_id'] = null, form['brand_id'] = null)"
                    :class="{ 'pr-8': form.errors[fieldName] || form.recentlySuccessful }"
                    :options="props.options.products_type"
                    :placeholder="props.fieldData.placeholder ?? 'Select your option'"
                    :canClear="!props.fieldData.required"
                    :mode="props.fieldData.mode ? props.fieldData.mode : 'single'"
                    :closeOnSelect="props.fieldData.mode == 'multiple' ? false : true"
                    :canDeselect="!props.fieldData.required"
                    :hideSelected="false"
                    :disabled="fieldData.readonly"
                    :caret="!fieldData.readonly"
                    :searchable="!!props.fieldData.searchable"
                    :label="fieldData.labelProp || 'label'"
                    :valueProp="fieldData.valueProp || 'value'"
                >
                    <template #singlelabel="{ value }">
                        <div class="w-full text-left pl-4">
                            {{ value.label }}
                            <Icon :data="value.icon" />
                        </div>
                    </template>

                    <template #option="{ option, isSelected, isPointed }">
                        <div class="">
                            {{ option.label }}
                            <Icon :data="option.icon" />
                        </div>
                    </template>
                </Multiselect>
                <div
                    v-if="form.errors[fieldName] || form.recentlySuccessful"
                    class="absolute inset-y-2/4 right-0 pr-3 flex items-center pointer-events-none bg-red-500">
                    <FontAwesomeIcon
                        icon="fas fa-exclamation-circle"
                        v-if="form.errors[fieldName]"
                        class="h-5 w-5 text-red-500"
                        aria-hidden="true" />
                    <FontAwesomeIcon
                        icon="fas fa-check-circle"
                        v-if="form.recentlySuccessful"
                        class="mt-1.5 h-5 w-5 text-green-500"
                        aria-hidden="true" />
                </div>

                <div class="absolute -top-2.5 text-sm bg-white py-0.5 px-2 leading-none left-2">
                    Tipe order
                </div>
            </div>
            <p v-if="form.errors[fieldName]" class="mt-2 text-sm text-red-600" id="email-error">
                {{ form.errors[fieldName] }}
            </p>
        </div>

        <!-- Brand -->
		<div v-show="form[fieldName] === 'tutup' || form[fieldName] === 'custom'" class="mt-6">
            <div class="relative"
                :class="form.errors['brand_id'] ? 'errorShake' : ''"
            >
                <div class="relative">
                    <PureMultiselectInfiniteScroll
                        v-model="form['brand_id']"
                        key="brand"
                        @update:modelValue="() => form.errors['brand_id'] = null"
                        :fetchRoute="fieldData.fetchBrandsRoute ?? { name: 'sales.brands.index' }"
                        :options="fieldData?.start_value?.brand"
                        labelProp="name"
                        required
                        placeholder="Pilih brand"
                        :errorLabel="{
                            title: 'Oops! Ada kesalahan',
                            text: 'Gagal mengambil data brand. Silahkan coba lagi.'
                        }"
                        class="py-1"
                        :disabled="sectionFields?.brand_id?.disabled"
                    >
                        <template #singlelabel="{ value }">
                            <div class="w-full text-left pl-4">{{ value.name }} <span class="text-sm text-gray-400">({{ value.order_count ?? 0 }} order)</span></div>
                        </template>
                        <template #option="{ option, isSelected, isPointed }">
                            <div class="">{{ option.name }} <span class="text-sm" :class="isSelected(option) ? 'text-indigo-200' : 'text-gray-400'">({{ option.order_count }} order)</span></div>
                        </template>
                    </PureMultiselectInfiniteScroll>

                    <div class="absolute -top-2.5 bg-white py-0.5 px-2 leading-none left-2">
                        Brand
                    </div>
                </div>
                
                

                <div
                    v-if="form.errors['brand_id'] || form.recentlySuccessful"
                    class="absolute inset-y-2/4 right-0 pr-3 flex items-center pointer-events-none bg-red-500">
                    <FontAwesomeIcon icon="fas fa-exclamation-circle" v-if="form.errors['brand_id']" class="h-5 w-5 text-red-500" aria-hidden="true" />
                    <FontAwesomeIcon icon="fas fa-check-circle" v-if="form.recentlySuccessful" class="mt-1.5 h-5 w-5 text-green-500" aria-hidden="true" />
                </div>
            </div>
            <p v-if="form.errors['brand_id']" class="mt-2 text-sm text-red-600" id="email-error">
                *{{ form.errors['brand_id'] }}
            </p>
        </div>

        <!-- Products -->
		<div v-if="form[fieldName]" class="mt-6">
            <div class="relative"
                :class="form.errors['product_id'] ? 'errorShake' : ''"
            >
                <div class="relative">
                    <PureMultiselectInfiniteScroll
                        :key="`product-${form[fieldName]}`"
                        v-model="form['product_id']"
                        :options="fieldData?.start_value?.product"
                        @update:modelValue="() => form.errors['product_id'] = null"
                        @selectedOption="(e) => selectedProduct = e"
                        required
                        :disabled="sectionFields?.product_id?.disabled"
                        :fetchRoute="compProductsRoute"
                        labelProp="name"
                        placeholder="Pilih produk"
                        :errorLabel="{
                            title: 'Oops! Ada kesalahan',
                            text: 'Gagal mengambil data produk. Silahkan coba lagi.'
                        }"
                        class="py-1"
                    >
                        <template #singlelabel="{ value }">
                            <div class="w-full text-left pl-4">{{ value.name }} <span v-if="form[fieldName] !== 'custom'" class="text-sm text-gray-400">({{ value.quantity ?? 0 }} pcs)</span></div>
                        </template>
                        <template #option="{ option, isSelected, isPointed }">
                            <div class="">{{ option.name }} <span v-if="form[fieldName] !== 'custom'" class="text-sm" :class="isSelected(option) ? 'text-indigo-200' : 'text-gray-400'">({{ option.quantity }} pcs)</span></div>
                        </template>
                    </PureMultiselectInfiniteScroll>
                    <div class="absolute -top-2.5 bg-white py-0.5 px-2 leading-none left-2">
                        Produk
                    </div>
                </div>

                <div
                    v-if="form.errors['product_id'] || form.recentlySuccessful"
                    class="absolute inset-y-2/4 right-0 pr-3 flex items-center pointer-events-none bg-red-500">
                    <FontAwesomeIcon icon="fas fa-exclamation-circle" v-if="form.errors['product_id']" class="h-5 w-5 text-red-500" aria-hidden="true" />
                    <FontAwesomeIcon icon="fas fa-check-circle" v-if="form.recentlySuccessful" class="mt-1.5 h-5 w-5 text-green-500" aria-hidden="true" />
                </div>
            </div>
            <p v-if="form.errors['product_id']" class="mt-2 text-sm text-red-600" id="email-error">
                *{{ form.errors['product_id'] }}
            </p>

            <div class="relative mt-6">
                <PureInput
                    v-model="form['quantity']"
                    @update:modelValue="() => form.errors['quantity'] = null"
                    type="number"
                    placeholder="0"
                    class="mt-4"
                    :class="
                        !!form.errors['quantity'] ? 'errorShake' : ''
                    "
                >
                    <!-- Icon: Error, Success, Loading -->
                    <template #stateIcon>
                        <div class="mr-2 h-full flex items-center pointer-events-none">
                            <FontAwesomeIcon v-if="get(form, ['errors', 'quantity'])"
                                icon="fas fa-exclamation-circle"
                                class="h-5 w-5 text-red-500" aria-hidden="true" />
                        </div>
                    </template>
                </PureInput>

                <div class="absolute -top-2.5 bg-white py-0.5 px-2 leading-none left-2">
                    Kuantiti
                </div>
            </div>

            <p v-if="form.errors['quantity']" class="mt-2 text-sm text-red-600" id="email-error">
                *{{ form.errors['quantity'] }}
            </p>


            <!-- Section: Keterangan Order -->
            <div v-if="selectedProduct?.is_able_include_tutup">
                <div class="mt-4 mb-1" >
                    Keterangan Order
                </div>
                <div class="flex flex-wrap gap-4"
                    :class="!!form.errors['keterangan_cetak'] ? 'errorShake' : ''"
                >
                    <div v-for="ketCet in optionsKeteranganCetak" class="flex items-center gap-2 cursor-pointer">
                        <RadioButton
                            v-model="form['keterangan_cetak']"
                            @update:modelValue="(value) => {
                                form.errors['keterangan_cetak'] = null
                            }"
                            xclick="() => {
                                if (form['keterangan_cetak'] === ketCet.label) {
                                    form['keterangan_cetak'] = null
                                }
                            }"
                            :inputId="`input-${ketCet.value}`"
                            name="ketcet"
                            :value="ketCet.label"
                        />
                        <label :for="`input-${ketCet.value}`" class="cursor-pointer py-1">{{ ketCet.label }}</label>
                    </div>
                </div>
                
                <p v-if="form.errors['keterangan_cetak']" class="mt-2 text-sm text-red-600" id="email-error">
                    *{{ form.errors['keterangan_cetak'] }}
                </p>
            </div>
        </div>

        <!-- Optional for Custom: Produk Tutup -->
		<div v-if="selectedProduct?.is_able_include_tutup" class="mt-6">
            <div class="border-l-8 border-fuchsia-400 px-4 bg-fuchsia-50 border pt-3 pb-4 mb-4 rounded-r-md">
                <div class="relative"
                    :class="form.errors['child_order_product_id'] ? 'errorShake' : ''"
                >
                    <div class="mb-1" >
                        Produk Tutup (tambahan)
                    </div>
                    <div class="relative">
                        <PureMultiselectInfiniteScroll
                            :key="`product-${form[fieldName]}`"
                            v-model="form['child_order_product_id']"
                            :options="fieldData?.start_value?.child_order_product_id"
                            @update:modelValue="() => {
                                form.errors['child_order_product_id'] = null
                                form.errors['child_order_quantity'] = null
                                form.child_order_quantity = null
                            }"
                            @selectedOption="(e) => selectedWithTutup = e"
                            :disabled="sectionFields?.child_order_product_id?.disabled"
                            :fetchRoute="props.fieldData?.fetchProductRoute.tutup"
                            labelProp="name"
                            placeholder="Pilih produk tutup"
                            :errorLabel="{
                                title: 'Oops! Ada kesalahan',
                                text: 'Gagal mengambil data produk tutup. Silahkan coba lagi.'
                            }"
                            class="py-1"
                        >
                            <template #singlelabel="{ value }">
                                <div class="w-full text-left pl-4">{{ value.name }} <span class="text-sm text-gray-400">({{ value.quantity ?? 0 }} pcs)</span></div>
                            </template>
                            <template #option="{ option, isSelected, isPointed }">
                                <div class="">{{ option.name }} <span class="text-sm" :class="isSelected(option) ? 'text-indigo-200' : 'text-gray-400'">({{ option.quantity }} pcs)</span></div>
                            </template>
                        </PureMultiselectInfiniteScroll>
                        <p v-if="form.errors['child_order_product_id']" class="mt-2 text-sm text-red-600" id="child_order_product_id-error">
                            *{{ form.errors['child_order_product_id'] }}
                        </p>
                    </div>
                    
                    <div class="mt-4 mb-1" >
                        Kuantiti Produk Tutup
                    </div>
                    <PureInput
                        v-model="form['child_order_quantity']"
                        @update:modelValue="() => form.errors['child_order_quantity'] = null"
                        type="number"
                        xplaceholder="selectedWithTutup ? `Maks. ${selectedWithTutup?.quantity} pcs` : 0"
                        placeholder="0"
                        :disabled="!form['child_order_product_id'] || sectionFields?.child_order_quantity?.disabled"
                        :class="
                            !!form.errors['child_order_quantity'] ? 'errorShake' : ''
                        "
                    >
                        <!-- Icon: Error, Success, Loading -->
                        <template #stateIcon>
                            <div class="mr-2 h-full flex items-center pointer-events-none">
                                <FontAwesomeIcon v-if="get(form, ['errors', 'child_order_quantity'])"
                                    icon="fas fa-exclamation-circle"
                                    class="h-5 w-5 text-red-500" aria-hidden="true" />
                            </div>
                        </template>
                    </PureInput>
                    
                    <p v-if="form.errors['child_order_quantity']" class="mt-2 text-sm text-red-600" id="child_order_quantity-error">
                        *{{ form.errors['child_order_quantity'] }}
                    </p>
                </div>

                <div v-if="fieldData.start_value?.child_order?.[0]" class="mt-4 text-sm">
                    <FontAwesomeIcon icon='fal fa-info-circle' class='text-gray-400' fixed-width aria-hidden='true' />
                    <!-- Tidak bisa mengubah  -->
                    <span class="ml-1 text-gray-600 mr-1">Untuk mengubah Order Tutup (tambahan)</span>
                    <Link :href="(generateLinkEditOrder(fieldData.start_value?.child_order?.[0]) as string)" class="py-2 inline-block font-medium underline xtext-sm">
                        Klik disini
                    </Link>
                </div>
            </div>
        </div>

        <!-- Design type -->
		<div v-show="form[fieldName] === 'tutup' || form[fieldName] === 'custom'" class="mt-6">
            <div class="relative"
                :class="form.errors['design_type'] ? 'errorShake' : ''"
            >
                <div class="relative">
                    <Multiselect
                        key="multiselect_product"
                        v-model="form['design_type']"
                        @update:modelValue="() => form.errors['design_type'] = null"
                        :class="{ 'pr-8': form.errors['design_type'] || form.recentlySuccessful }"
                        :options="props.options.design_type"
                        placeholder="Tipe desain"
                        :canClear="false"
                        :closeOnSelect="true"
                        :canDeselect="false"
                        :hideSelected="false"
                        :disabled="!form[fieldName] || sectionFields?.design_type?.disabled"
                        :caret="true"
                        label="name"
                        valueProp="id"
                        class="py-1"
                    />
                    <div class="absolute -top-2.5 bg-white py-0.5 px-2 leading-none left-2">
                        Desain
                    </div>
                </div>
                <div
                    v-if="form.errors['design_type'] || form.recentlySuccessful"
                    class="absolute inset-y-2/4 right-0 pr-3 flex items-center pointer-events-none bg-red-500">
                    <FontAwesomeIcon icon="fas fa-exclamation-circle" v-if="form.errors['design_type']" class="h-5 w-5 text-red-500" aria-hidden="true" />
                    <FontAwesomeIcon icon="fas fa-check-circle" v-if="form.recentlySuccessful" class="mt-1.5 h-5 w-5 text-green-500" aria-hidden="true" />
                </div>
            </div>
            <p v-if="form.errors['design_type']" class="mt-2 text-sm text-red-600" id="email-error">
                *{{ form.errors['design_type'] }}
            </p>
        </div>

        <!-- <pre>{{ Object.keys(sectionFields) }}</pre> -->
	</div>

</template>

<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
/* Style for multiselect globally */
:deep(.multiselect-option.is-selected),
:deep(.multiselect-option.is-selected.is-pointed) {
	background: var(--ms-option-bg-selected, #6366f1) !important;
	color: var(--ms-option-color-selected, #fff) !important;
}

:deep(.multiselect-option.is-selected.is-disabled) {
	background: var(--ms-option-bg-selected-disabled, #c7d2fe);
	color: var(--ms-option-color-selected-disabled, #818cf8);
}

:deep(.multiselect.is-active) {
	border: var(--ms-border-width-active, var(--ms-border-width, 1px)) solid
		var(--ms-border-color-active, var(--ms-border-color, #d1d5db));
	box-shadow: 0 0 0 var(--ms-ring-width, 3px) var(--ms-ring-color, rgba(99, 102, 241, 0.188));
}
</style>
